// @ts-nocheck
import React, { useRef, useState } from "react";
import { Galleria } from "primereact/galleria";
import styles from "./Editions.module.css";
import editionsContent from "../../assets/json/editionsContent";
import EditionCard from "./EditionCard";

const Editions = () => {
  const totalParticipants = editionsContent.reduce(
    (acc, ed) => acc + ed.participants,
    0,
  );
  const firstParticipants = editionsContent[0]?.participants ?? 0;
  const lastParticipants =
    editionsContent[editionsContent.length - 1]?.participants ?? 0;
  const growth =
    firstParticipants > 0
      ? Math.round(
          ((lastParticipants - firstParticipants) / firstParticipants) * 100,
        )
      : 0;

  const galleriaRef = useRef(null);
  const [activeEdition, setActiveEdition] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const buildImages = (ed) => {
    const all = [ed.cover, ...(ed.gallery || [])];
    const unique = Array.from(new Set(all));
    return unique.map((src, i) => ({
      itemImageSrc: src,
      thumbnailImageSrc: src,
      alt: `${ed.name} - foto ${i + 1}`,
      title: ed.name,
    }));
  };

  const openGallery = (ed, index = 0) => {
    setActiveEdition(ed);
    setActiveIndex(index);
    setTimeout(() => galleriaRef.current?.show(), 0);
  };

  const itemTemplate = (item) => (
    <img
      src={item.itemImageSrc}
      alt={item.alt}
      className={styles.galleriaItem}
    />
  );

  const thumbnailTemplate = (item) => (
    <img
      src={item.thumbnailImageSrc}
      alt={item.alt}
      className={styles.galleriaThumb}
    />
  );

  const captionTemplate = (item) => (
    <span className={styles.galleriaCaption}>{item.title}</span>
  );

  return (
    <section className={styles.section}>
      <div className={styles.timeline}>
        <div className={styles.timelineLine} aria-hidden="true" />

        {editionsContent.map((ed, index) => {
          const isLeft = index % 2 === 0;
          const prev = editionsContent[index - 1];
          const delta = prev
            ? Math.round(
                ((ed.participants - prev.participants) / prev.participants) *
                  100,
              )
            : null;

          return (
            <div
              key={ed.edition}
              className={`${styles.row} ${isLeft ? styles.rowLeft : styles.rowRight}`}
            >
              <EditionCard
                edition={ed}
                delta={delta}
                onOpenGallery={openGallery}
              />
              <div className={styles.marker} aria-hidden="true">
                <span className={styles.markerInner}>{ed.edition}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.statsStrip}>
        <div className={styles.stat}>
          <span className={styles.statValue}>{editionsContent.length}</span>
          <span className={styles.statLabel}>edições realizadas</span>
        </div>
        <span className={styles.statDivider} />
        <div className={styles.stat}>
          <span className={styles.statValue}>{totalParticipants}+</span>
          <span className={styles.statLabel}>participantes ao total</span>
        </div>
        <span className={styles.statDivider} />
        <div className={styles.stat}>
          <span className={styles.statValue}>+{growth}%</span>
          <span className={styles.statLabel}>de crescimento</span>
        </div>
      </div>

      <Galleria
        ref={galleriaRef}
        value={activeEdition ? buildImages(activeEdition) : []}
        activeIndex={activeIndex}
        onItemChange={(e) => setActiveIndex(e.index)}
        numVisible={5}
        circular
        fullScreen
        showItemNavigators
        showThumbnails
        item={itemTemplate}
        thumbnail={thumbnailTemplate}
        caption={captionTemplate}
      />
    </section>
  );
};

export default Editions;
